import axios from "axios";
import config from "../config";
import userService from "../services/userService";

export const changeField = ({field, value}) => {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_FIELD',
            payload: {
                field,
                value
            }
        })
    }
}

export const preloaderStart = () => {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_FIELD',
            payload: {
                field: 'isPreloaderActive',
                value: true
            }
        })
    }
}

export const preloaderStop = () => {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_FIELD',
            payload: {
                field: 'isPreloaderActive',
                value: false
            }
        })
    }
}

export const changePage = ({pageName}) => {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_FIELD',
            payload: {
                field: 'currentPage',
                value: pageName
            }
        })
    }
}

export const uploadDLFrontPage = ({imageBase64}) => {
    return (dispatch) => {

        dispatch(preloaderStart())

        axios({
            method: 'post',
            url: config.dlFrontOcrUrl,
            data: {
                document: imageBase64
            }
        }).then((res) => {

            const result = res.data

            const fields = result.payload

            fields.forEach((item) => {

                if (item.label === 'dl_number') {
                    dispatch(changeField({
                        field: 'dlNumber',
                        value: item.value
                    }))
                }

                if (item.label === 'dl_exp') {
                    dispatch(changeField({
                        field: 'expDate',
                        value: item.value
                    }))
                }

                if (item.label === 'date_of_birth') {
                    dispatch(changeField({
                        field: 'dateOfBirth',
                        value: item.value
                    }))
                }

                if (item.label === 'dl_first_name') {
                    dispatch(changeField({
                        field: 'firstName',
                        value: item.value
                    }))
                }

                if (item.label === 'dl_last_name') {
                    dispatch(changeField({
                        field: 'lastName',
                        value: item.value
                    }))
                }

                if (item.label === 'dl_categories') {
                    const dlCategory = item.value.toLowerCase()
                    if (dlCategory !== 'am' || dlCategory !== 'a1' || dlCategory !== 'a2' || dlCategory !== 'a') {
                        dispatch(changeField({
                            field: 'categoryB',
                            value: true
                        }))
                    }
                }

            })

            dispatch(changeField({
                field: 'currentPhoto',
                value: false
            }))

            dispatch(
                changePage({
                    pageName: 'dl-back-page'
                })
            )

            dispatch(preloaderStop())
        }).catch((err) => {
            dispatch(preloaderStop())

            dispatch(changeField({
                field: 'currentPhoto',
                value: false
            }))

            dispatch(
                changePage({
                    pageName: 'dl-back-page'
                })
            )

        })
    }
}

export const uploadDLBackPage = ({imageBase64}) => {
    return (dispatch) => {

        dispatch(changeField({
            field: 'currentPhoto',
            value: false
        }))

        dispatch(
            changePage({
                pageName: 'document-data-page'
            })
        )
    }
}

export const uploadPassport = ({imageBase64}) => {
    return (dispatch) => {
        dispatch(preloaderStart())

        axios({
            method: 'post',
            url: config.pasFrontOcrUrl,
            data: {
                document: imageBase64
            }
        }).then((res) => {
            dispatch(preloaderStop())

            const result = res.data

            const fields = result.payload

            fields.forEach((item) => {

                if (item.label === 'i_pas_number') {

                    if (item.value !== null) {
                        dispatch(changeField({
                            field: 'idcardpasNumber',
                            value: item.value
                        }))
                    }


                }

                if (item.label === 'i_pas_exp_date') {

                    if (item.value !== null) {
                        dispatch(changeField({
                            field: 'idcardpasExpdate',
                            value: item.value
                        }))
                    }


                }

                if (item.label === 'i_pas_country') {

                    if (item.value !== null) {
                        dispatch(changeField({
                            field: 'idcardpasCountry',
                            value: item.value
                        }))
                    }


                }

            })

            dispatch(changeField({
                field: 'currentPhoto',
                value: false
            }))

            dispatch(
                changePage({
                    pageName: 'not-dutch-document-data-page'
                })
            )
        }).catch((err) => {
            dispatch(preloaderStop())

            dispatch(changeField({
                field: 'currentPhoto',
                value: false
            }))

            dispatch(
                changePage({
                    pageName: 'not-dutch-document-data-page'
                })
            )
        })

    }
}

export const uploadIdCardFront = ({imageBase64}) => {
    return (dispatch) => {
        dispatch(preloaderStart())

        axios({
            method: 'post',
            url: config.idCardFrontOcrUrl,
            data: {
                document: imageBase64
            }
        }).then((res) => {

            const result = res.data

            const fields = result.payload

            fields.forEach((item) => {

                if (item.label === 'id_card_number') {
                    dispatch(changeField({
                        field: 'idcardpasNumber',
                        value: item.value
                    }))
                }

                if (item.label === 'id_card_exp_date') {
                    dispatch(changeField({
                        field: 'idcardpasExpdate',
                        value: item.value
                    }))
                }

                if (item.label === 'id_card_country') {
                    dispatch(changeField({
                        field: 'idcardpasCountry',
                        value: item.value
                    }))
                }

            })

            dispatch(changeField({
                field: 'currentPhoto',
                value: false
            }))

            dispatch(
                changePage({
                    pageName: 'idcard-back-page'
                })
            )

            dispatch(preloaderStop())
        }).catch((err) => {
            dispatch(preloaderStop())

            dispatch(changeField({
                field: 'currentPhoto',
                value: false
            }))

            dispatch(
                changePage({
                    pageName: 'idcard-back-page'
                })
            )

        })

    }
}

export const uploadIdCardBack = ({imageBase64}) => {
    return (dispatch) => {
        //dispatch(preloaderStart())

        dispatch(changeField({
            field: 'currentPhoto',
            value: false
        }))

        dispatch(
            changePage({
                pageName: 'not-dutch-document-data-page'
            })
        )
    }
}

export const putDLFrontPhotoToResult = ({imageBase64}) => {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_DL_FRONT_PAGE_RESULT',
            payload: imageBase64
        })
    }
}

export const putDLBackPhotoToResult = ({imageBase64}) => {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_DL_BACK_PAGE_RESULT',
            payload: imageBase64
        })
    }
}

export const putPassportPhotoToResult = ({imageBase64}) => {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_PASSPORT_PAGE_RESULT',
            payload: imageBase64
        })
    }
}

export const putIdcardFrontPhotoToResult = ({imageBase64}) => {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_ID_CARD_FRONT_PAGE_RESULT',
            payload: imageBase64
        })
    }
}

export const putIdcardBackPhotoToResult = ({imageBase64}) => {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_ID_CARD_BACK_PAGE_RESULT',
            payload: imageBase64
        })
    }
}

export const experianValidateDL = ({dlNumber, dateOfBirth, cb, errCb}) => {
    return (dispatch) => {
        dispatch(preloaderStart())

        axios({
            method: 'post',
            url: config.experianDLUrl,
            data: {
                document_type: 'drivers_license',
                document_id: `${dlNumber}`,
                date_of_birth: `${dateOfBirth}`
            }
        }).then((res) => {

            const resData = res.data

            cb(resData)

            dispatch(preloaderStop())
        }).catch((err) => {
            errCb(err)
            dispatch(preloaderStop())
        })
    }
}

export const putSelfieToResult = ({imageBase64}) => {
    return (dispatch) => {
        dispatch({
            type: 'CHANGE_SELFIE_RESULT',
            payload: imageBase64
        })
    }
}

export const hideErrorMessage = () => {
    return (dispatch) => {
        dispatch({
            type: 'HIDE_ERROR_MESSAGE'
        })
    }
}

export const showErrorMessage = ({title, message}) => {
    return (dispatch) => {
        dispatch({
            type: 'SHOW_ERROR_MESSAGE',
            payload: {
                title,
                message
            }
        })
    }
}

export const makeRegistration = ({userObject}) => {
    return (dispatch) => {

        dispatch(preloaderStart())

        userService
            .makeShortRegistration({
                registration_source: 'website',
                customer_type: 'private',
                gender: userObject.gender,
                first_name: userObject.firstName,
                last_name: userObject.lastName,
                mobile_phone_number: userObject.phone,
                email_address: userObject.email,
                password: userObject.needTempPassword ? '123456' : userObject.password,
                generate_ephemeral_password: userObject.needTempPassword,
                place_of_birth: userObject.livingAddress.city,
                country_of_birth: userObject.livingAddress.country,
                nationality: userObject.livingAddress.country,
                date_of_birth: userObject.birthDate,
                residence_address: {
                    zip_code: userObject.livingAddress.zipCode,
                    house_number: userObject.livingAddress.houseNumber,
                    house_number_extension: userObject.livingAddress.houseNumberExtension,
                    street_name: userObject.livingAddress.streetName,
                    city: userObject.livingAddress.city,
                    country: userObject.livingAddress.country
                },
                address: {
                    zip_code: userObject.invoiceAddress.zipCode,
                    house_number: userObject.invoiceAddress.houseNumber,
                    house_number_extension: userObject.invoiceAddress.houseNumberExtension,
                    street_name: userObject.invoiceAddress.streetName,
                    city: userObject.invoiceAddress.city,
                    country: userObject.invoiceAddress.country
                }
            })
            .then((res) => {

                const apiToken = res.data.token

                userService
                    .getClientInfo(apiToken)
                    .then((clientRes) => {
                        const clientId = clientRes.data[0].id

                        userService
                            .signContract({
                                customerId: clientId,
                                base64Image: 'iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAAFElEQVR42mNkIBIwjiocVTiqEAQAJNYAFd868w4AAAAASUVORK5CYII=',
                                apiToken
                            })
                            .then((signContractRes) => {

                                userService
                                    .uploadDriverLicense({
                                        apiToken,
                                        driverLicenseNumber: userObject.documents.dl.number,
                                        expirationDate: userObject.documents.dl.expDate,
                                        categories: ['B'],
                                        country: userObject.documents.dl.country,
                                        frontImage: userObject.documents.dl.front,
                                        backImage: userObject.documents.dl.back
                                    })
                                    .then((res) => {

                                        if (userObject.documents.passport !== false) {
                                            userService.uploadPassport({
                                                apiToken,
                                                passportNumber: userObject.documents.passport.number,
                                                expirationDate: userObject.documents.passport.expDate,
                                                country: userObject.documents.passport.country,
                                                frontImage: userObject.documents.passport.front
                                            }).then((pasRes) => {
                                                dispatch(preloaderStop())

                                                dispatch(changePage({
                                                    pageName: 'done-page'
                                                }))

                                            }).catch((pasErr) => {
                                                dispatch(showErrorMessage({
                                                    message: pasErr.response.data.error.message,
                                                    title: 'Something wrong'
                                                }))
                                                dispatch(preloaderStop())
                                            })
                                        } else if (userObject.documents.idcard !== false) {

                                            userService.uploadIdCard({
                                                apiToken,
                                                documentNumber: userObject.documents.idcard.number,
                                                expirationDate: userObject.documents.idcard.expDate,
                                                country: userObject.documents.idcard.country,
                                                frontImage: userObject.documents.idcard.front,
                                                backImage: userObject.documents.idcard.back
                                            }).then((idCardRes) => {

                                                dispatch(preloaderStop())

                                                dispatch(changePage({
                                                    pageName: 'done-page'
                                                }))

                                            }).catch((idCardErr) => {
                                                dispatch(showErrorMessage({
                                                    message: idCardErr.response.data.error.message,
                                                    title: 'Something wrong'
                                                }))
                                                dispatch(preloaderStop())
                                            })
                                        } else {
                                            dispatch(preloaderStop())

                                            dispatch(changePage({
                                                pageName: 'done-page'
                                            }))
                                        }

                                    })
                                    .catch((dlRrr) => {
                                        dispatch(showErrorMessage({
                                            message: dlRrr.response.data.error.message,
                                            title: 'Something wrong'
                                        }))
                                        dispatch(preloaderStop())
                                    })
                            })
                            .catch((signContractErr) => {
                                dispatch(preloaderStop())
                            })

                    })
                    .catch((clientErr) => {
                        dispatch(preloaderStop())
                    })

            })
            .catch((err) => {
                dispatch(preloaderStop())
                dispatch(showLoginPopup())
            })
    }
}

export const showLoginPopup = () => {
    return (dispatch) => {
        dispatch({
            type: 'SHOW_LOGIN_POPUP'
        })
    }
}

export const hideLoginPopup = () => {
    return (dispatch) => {
        dispatch({
            type: 'HIDE_LOGIN_POPUP'
        })
    }
}

export const zipCodeAutocomplete = ({zipCode, houseNumber, additionalHouseNumber}) => {
    return (dispatch) => {

        dispatch(preloaderStart())

        axios({
            method: 'get',
            url: config.getZipCodeUrl({
                zipCode,
                houseNumber,
                additionalHouseNumber
            })
        }).then((res) => {

            const {street, city} = res.data.payload

            dispatch(changeField({
                field: 'streetLiving',
                value: street
            }))

            dispatch(changeField({
                field: 'cityLiving',
                value: city
            }))

            dispatch(preloaderStop())
        }).catch((err) => {
            dispatch(preloaderStop())
        })
    }
}

export const resetPassword = ({email, cbSuccess}) => {
    return (dispatch) => {

        dispatch(preloaderStart())
        dispatch(hideLoginPopup())

        userService
            .resetPassword({
                email
            })
            .then((res) => {

                cbSuccess()



                dispatch(preloaderStop())
            })
            .catch((err) => {
                dispatch(preloaderStop())
            })
    }
}
